
export default {
    public: {
    },
    settings: '/cai-dat',
    account: '/tai-khoan',
    // Admin
    user: {
        name: 'admin/user',
        list: '/admin/user/list',
        add: '/admin/user/add',
        edit: '/admin/user/edit/:id',
        detail: '/admin/user/detail/:id',
        changePWD: '/admin/user/doi-mat-khau'

    },
    warehouse: {
        name: 'admin/warehouse',
        list: '/admin/warehouse/list',
        add: '/admin/warehouse/add',
        edit: '/admin/warehouse/edit/:id',
        detail: '/admin/warehouse/detail/:id',
    },

    transProvider: {
        name: 'admin/trans-provider',
        list: '/admin/trans-provider/list',
        add: '/admin/trans-provider/add',
        edit: '/admin/trans-provider/edit/:id',
        detail: '/admin/trans-provider/detail/:id',
    },
    currencyProvider: {
        name: 'admin/currency-provider',
        list: '/admin/currency-provider/list',
        add: '/admin/currency-provider/add',
        edit: '/admin/currency-provider/edit/:id',
        detail: '/admin/currency-provider/detail/:id',
    },
    taxProvider: {
        name: 'admin/tax-provider',
        list: '/admin/tax-provider/list',
        add: '/admin/tax-provider/add',
        edit: '/admin/tax-provider/edit/:id',
        detail: '/admin/tax-provider/detail/:id',
    },

    supplier: {
        name: 'admin/supplier',
        list: '/admin/supplier/list',
        add: '/admin/supplier/add',
        edit: '/admin/supplier/edit/:id',
        detail: '/admin/supplier/detail/:id',
        import: '/admin/supplier/import',
    },

    transportation: {
        name: 'admin/transportation',
        list: '/admin/transportation/list',
        add: '/admin/transportation/add',
        edit: '/admin/transportation/edit/:id',
        detail: '/admin/transportation/detail/:id',
        import: '/admin/transportation/import',
    },
    container: {
        name: 'order-container/container',
        list: '/order-container/container/list',
        add: '/order-container/container/add',
        edit: '/order-container/container/edit/:id',
        updateInfo: '/order-container/container/update-info/:id',
        detail: '/order-container/container/detail/:id',
        import: '/order-container/container/import',
    },
    rate: {
        name: 'admin/rate',
        list: '/admin/rate/list',
        add: '/admin/rate/add',
        edit: '/admin/rate/edit/:id',
        detail: '/admin/rate/detail/:id',
    },
    product: {
        name: 'admin-product/product',
        list: '/admin-product/product/list',
        listProductSupplier: '/admin-product/product-supplier/list',
        listProductWarehouse: '/admin-product/product-warehouse/list',
        listAll: '/admin-product/product-supplier-warehouse/list',
        add: '/admin-product/product/add',
        edit: '/admin-product/product/edit/:id',
        detail: '/admin-product/product/detail/:id',
        import: '/admin-product/product/import',
        log: '/admin-product/product/log/:id',
    },
    categorie: {
        name: 'admin-product/categorie',
        list: '/admin-product/categorie/list',
        add: '/admin-product/categorie/add',
        edit: '/admin-product/categorie/edit/:id',
        detail: '/admin-product/categorie/detail/:id',
        import: '/admin-product/categorie/import',
    },
    productGroup: {
        name: 'admin-product/product-group',
        list: '/admin-product/product-group/list',
        add: '/admin-product/product-group/add',
        edit: '/admin-product/product-group/edit/:id',
        detail: '/admin-product/product-group/detail/:id',
        import: '/admin-product/product-group/import',
    },
    priceCategorie: {
        name: 'admin-product/price-categorie',
        list: '/admin-product/price-categorie/list',
        add: '/admin-product/price-categorie/add',
        edit: '/admin-product/price-categorie/edit/:id',
        detail: '/admin-product/price-categorie/detail/:id',
        import: '/admin-product/price-categorie/import',
    },

    // yêu cầu mua hàng
    purchasesRequest: {
        name: 'order/purchases-request',
        list: '/order/purchases-request/list',
        add: '/order/purchases-request/add',
        addMulti: '/order/purchases-request/add-multi',
        edit: '/order/purchases-request/edit/:id',
        detail: '/order/purchases-request/detail/:id',
        import: '/order/purchases-request/import',
        log: '/order/purchases-request/log/:id',

    },

    // yêu cầu tách
    requestShare: {
        name: 'order/request-share',
        list: '/order/request-share/list',
        add: '/order/request-share/add',
        edit: '/order/request-share/edit/:id',
        detail: '/order/request-share/detail/:id',
        import: '/order/request-share/import',
    },
    // báo giá
    pricing: {
        name: 'order/pricing/',
        list: '/order/pricing/list',
        add: '/order/pricing/add',
        edit: '/order/pricing/edit/:id',
        detail: '/order/pricing/detail/:id',
        log: '/order/pricing/log/:id',

    },
    // báo giá V2 - Performance improved
    pricingV2: {
        name: 'order/pricing-v2/',
        list: '/order/pricing-v2/list',
        add: '/order/pricing-v2/add',
        edit: '/order/pricing-v2/edit/:id',
        detail: '/order/pricing-v2/detail/:id',
    },
    // Xác nhận báo giá
    pricingConfirm: {
        name: 'order/pricing-confirm',
        list: '/order/pricing-confirm/list',
        add: '/order/pricing-confirm/add',
        edit: '/order/pricing-confirm/edit/:id',
        detail: '/order/pricing-confirm/detail/:id',
    },
    // đơn hàng
    order: {
        name: 'order/order/',
        list: '/order/order/list',
        add: '/order/order/add',
        edit: '/order/order/edit/:id',
        detail: '/order/order/detail/:id',
        updateReality: '/order/order/update-reality/:id',
        log: '/order/order/log/:id',

    },
    // yêu cầu thanh toán
    requestPayment: {
        name: 'order/request-payment',
        list: '/order/request-payment/list',
        add: '/order/request-payment/add',
        edit: '/order/request-payment/edit/:id',
        detail: '/order/request-payment/detail/:id',
        log: '/order/request-payment/log/:id',
    },
    // thanh toán
    paymentOrder: {
        name: 'order/payment-order',
        list: '/order/payment-order/list',
        add: '/order/payment-order/add',
        edit: '/order/payment-order/edit/:id',
        detail: '/order/payment-order/detail/:id',
        payment: '/order/payment-order/payment/:id',
        log: '/order/payment-order/log/:id',
    },

    // báo cáo
    // thanh toán
    report: {
        name: 'report',
        reportDeptDetail: '/report/debt/:loaidoituong/:id',
        reportDeptList: '/report/debt/:loaidoituong',

        reportDeptList_NCC_THUCTE: '/report/debt/congno-ncc-thucte',
        reportDeptList_NCC_NGAYPHATHANGTHUCTE: '/report/debt/congno-ncc-phathang',
        reportDeptList_NCC_NGAYDATHANGTHUCTE: '/report/debt/congno-ncc-dathang',
        reportDeptList_NCCVC: '/report/debt/congno-ncc-vanchuyen',
        reportDeptList_NCCTIENTE: '/report/debt/congno-ncc-tiente',
        reportDeptList_NCCTHUE: '/report/debt/congno-ncc-thue',

        reportDeptDetail_NCC_THUCTE: '/report/debt/congno-ncc-thucte/:id',
        reportDeptDetail_NCC_NGAYPHATHANGTHUCTE: '/report/debt/congno-ncc-phathang/:id',
        reportDeptDetail_NCC_NGAYDATHANGTHUCTE: '/report/debt/congno-ncc-dathang/:id',
        reportDeptDetail_NCCVC: '/report/debt/congno-ncc-vanchuyen/:id',
        reportDeptDetail_NCCTIENTE: '/report/debt/congno-ncc-tiente/:id',
        reportDeptDetail_NCCTHUE: '/report/debt/congno-ncc-thue/:id',
    },

    balanceOfdebt: {
        name: 'report/balance-of-debt',
        list: '/report/balance-of-debt/list',
        add: '/report/balance-of-debt/add',
        edit: '/report/balance-of-debt/edit/:id',
        detail: '/report/balance-of-debt/detail/:id',
        import: '/report/balance-of-debt/import',
        log: '/report/balance-of-debt/log/:id',
        orderAdd: '/report/balance-of-debt-order/add',
    },

    /** Menu Công nợ mới (chốt kỳ) — báo cáo /report/debt/* giữ nguyên */
    congNo: {
        name: 'cong-no',
        detail: '/cong-no/:loaidoituong/:id',
        list: '/cong-no/:loaidoituong',
        /** 1 trang lịch sử chốt — lọc loại công nợ bằng query `loaidoituong`. */
        chotHistoryList: '/cong-no/lich-su-chot',
        /** Alias cũ theo slug (vẫn mở cùng trang). */
        chotHistory: '/cong-no/:loaidoituong/lich-su-chot',
        list_NCC_THUCTE: '/cong-no/congno-ncc-thucte',
        list_NCC_NGAYPHATHANGTHUCTE: '/cong-no/congno-ncc-phathang',
        list_NCC_NGAYDATHANGTHUCTE: '/cong-no/congno-ncc-dathang',
        list_NCCVC: '/cong-no/congno-ncc-vanchuyen',
        list_NCCTIENTE: '/cong-no/congno-ncc-tiente',
        list_NCCTHUE: '/cong-no/congno-ncc-thue',
        detail_NCC_THUCTE: '/cong-no/congno-ncc-thucte/:id',
        detail_NCC_NGAYPHATHANGTHUCTE: '/cong-no/congno-ncc-phathang/:id',
        detail_NCC_NGAYDATHANGTHUCTE: '/cong-no/congno-ncc-dathang/:id',
        detail_NCCVC: '/cong-no/congno-ncc-vanchuyen/:id',
        detail_NCCTIENTE: '/cong-no/congno-ncc-tiente/:id',
        detail_NCCTHUE: '/cong-no/congno-ncc-thue/:id',
        chotHistory_NCC_THUCTE: '/cong-no/congno-ncc-thucte/lich-su-chot',
        chotHistory_NCC_NGAYPHATHANGTHUCTE: '/cong-no/congno-ncc-phathang/lich-su-chot',
        chotHistory_NCC_NGAYDATHANGTHUCTE: '/cong-no/congno-ncc-dathang/lich-su-chot',
        chotHistory_NCCVC: '/cong-no/congno-ncc-vanchuyen/lich-su-chot',
        chotHistory_NCCTIENTE: '/cong-no/congno-ncc-tiente/lich-su-chot',
        chotHistory_NCCTHUE: '/cong-no/congno-ncc-thue/lich-su-chot',
    },


    notification: {
        name: 'notification',
        list: '/notification/list',
    },
    historyOrder: {
        name: '/history/history-order/',
        list: '/history/history-order/list',
        detail: '/history/history-order/detail/:id',
        taoPhieuNhan: '/history/history-order/tao-phieu-nhan',
    },
    historyReality: {
        name: '/history/history-reality/',
        list: '/history/history-reality/list',
        updateList: '/history/history-reality/update-list',
        detail: '/history/history-reality/detail/:id',
        log: '/history/history-reality/log/:id',
    },
    historyOrderDeleted: {
        name: '/history/history-order-deleted/',
        list: '/history/history-order-deleted/list',
    },
    lichSuHoatDong: {
        name: '/history/lich-su-hoat-dong/',
        list: '/history/lich-su-hoat-dong/list',
        tatCa: '/history/lich-su-hoat-dong/tat-ca',
    },
    orderPurchasesReality: {
        name: '/order/order-purchases-reality/',
        list: '/order/order-purchases-reality/list',
        detail: '/order/order-purchases-reality/detail/:id',
    },

    orderPurchasesUpdate: {
        name: '/order/order-purchases-update/',
        list: '/order/order-purchases-update/list',
        detail: '/order/order-purchases-update/detail/:id',
    },

    billOfLadingCode: {
        name: 'bill-of-lading-code',
        edit: '/bill-of-lading-code/edit/:id',
        list: '/bill-of-lading-code/list',
        import: '/bill-of-lading-code/import',
    },

    test: {
        name: 'admin/test',
        list: '/admin/test/list',
    },

    // yêu cầu tìm hàng
    searchRequest: {
        name: 'find-product/search-request/',
        list: '/find-product/search-request/list',
        add: '/find-product/search-request/add',
        addMulti: '/find-product/search-request/add-multi',
        edit: '/find-product/search-request/edit/:id',
        detail: '/find-product/search-request/detail/:id',
        import: '/find-product/search-request/import',
        log: '/find-product/search-request/log/:id',
    },

    productPricing: {
        name: 'find-product/product-pricing/',
        list: '/find-product/product-pricing/list',
        add: '/find-product/product-pricing/add',
        edit: '/find-product/product-pricing/edit/:id',
        detail: '/find-product/product-pricing/detail/:id',
        addMulti: '/find-product/product-pricing/add-multi',
        log: '/find-product/product-pricing/log/:id',
    },
    productPricingDraft: {
        name: 'find-product/product-pricing-draft/',
        list: '/find-product/product-pricing-draft/list',
    },
    productPricingConfirm: {
        name: 'find-product/product-pricing-confirm/',
        list: '/find-product/product-pricing-confirm/list',
        detail: '/find-product/product-pricing-confirm/detail/:id',
    },
    productPricingHistory: {
        name: 'find-product/product-pricing-history/',
        list: '/find-product/product-pricing-history/list',
    },

    logAdminProduct: {
        name: '/admin-product/',
        list: '/admin-product/log/product/list',
    },

    logFindProduct: {
        name: '/find-product/',
        searchRequestList: '/find-product/log/search-request/list',
        productPricingList: '/find-product/log/product-pricing/list',
    },

}
